export default __webpack_public_path__ + "static/media/hp-context-snippet-img.a59da31a.svg";